module.exports = __webpack_public_path__ + "static/media/wcp_han_con.ab9d77cc.png";